import { useEffect, useState } from "react";
import { taskRequest } from "./api";

export default function useBoardBackground(board) {
  const boardId = board && board.id;
  const filename = board && board.backgroundImage;
  const key = `${boardId}:${filename}`;
  const [preview, setPreview] = useState({});
  useEffect(() => {
    if (!filename) return;
    let active = true;
    let timer;
    const refresh = async () => {
      let delay = 10 * 60 * 1000;
      try {
        const result = await taskRequest("get_task_board_background", { boardId });
        if (active) setPreview({ key, url: result.url });
      } catch (error) {
        if (active) setPreview((previous) => ({ ...(previous.key === key ? previous : { key }), error: error.message }));
        delay = 60000;
      }
      if (active) timer = window.setTimeout(refresh, delay);
    };
    refresh();
    return () => { active = false; window.clearTimeout(timer); };
  }, [boardId, filename, key]);
  return {
    error: filename && preview.key === key ? preview.error : undefined,
    style: {
      backgroundColor: (board && board.backgroundColor) || undefined,
      backgroundImage: filename && preview.key === key && preview.url ? `url(${JSON.stringify(preview.url)})` : undefined,
      backgroundSize: "cover",
      backgroundPosition: "center",
    },
  };
}
